import { Permission } from "constants/permission.types";
import { hasAccess } from "constants/permission.utils";


export const filterMenuByPermission = (
  menu: any[],
  permissions: Permission[]
) => {
  return menu
    .map(item => {
      const parentKey = item.key?.toLocaleLowerCase().trim();

      // CASE 1: HAS CHILDREN
      if (item?.children && item?.children?.length > 0) {
        const allowedChildren = item.children.filter((child: any) =>
          hasAccess(child.key?.toLocaleLowerCase().trim(), permissions)
        );

        // if ALL children hidden → hide parent
        if (allowedChildren?.length === 0) {
          return null;
        }

        // show parent with ONLY allowed children
        return {
          ...item,
          children: allowedChildren,
          display: true,
        };
      }

      // CASE 2: NO CHILDREN → check parent permission
      if (parentKey && hasAccess(parentKey, permissions)) {
        return {
          ...item,
          display: true,
        };
      }

      // hide parent
      return null;
    })
    .filter(Boolean);
};
